import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'
import { DialogDescription } from '@radix-ui/react-dialog'
import { Spinner } from './ui/spinner'

export function BaseDialog({
  open,
  onOpenChange,
  title,
  header,
  children,
  footer,
  isLoading,
  dialogContentClass,
  contentTestId,
}: {
  open: boolean
  onOpenChange: (v: boolean) => void
  title?: string
  header?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  isLoading?: boolean
  dialogContentClass?: string
  contentTestId?: string
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={contentTestId}
        className={cn('flex flex-col sm:max-w-lg max-h-[90vh] bg-card overflow-visible', dialogContentClass)}
      >
        <DialogHeader>
          <DialogTitle className="flex gap-2 items-center">
            {header ?? title}
            {isLoading && <Spinner className="size-3 opacity-70" />}
          </DialogTitle>
          <DialogDescription className="sr-only"></DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto p-1">{children}</div>

        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  )
}
